/** @jsxImportSource @emotion/react */
import * as React from "react";
import UploadIcon from "../Icons/uploadIcon";
import CloseIcon from "../Icons/closeIcon";
import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "../../hooks/useCSSRulesWithTheme";
import { useUIStore } from "../../hooks/useUIStore";
import { getThemeColorFromAlias, theme } from "../../theme";

interface UploadInputProps {
  label: string;
  onClick?: () => void | any;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileType: string;
  file: File | null;
  fileName: string;
  onDelete: () => void;
  name?: string;
  id?: string;
}

const getStyles: CSSRulesResolver<{ tabColor: string }> = (props) => ({
  inputLabel: {
    position: "relative" as "relative",
    display: "inline-block",
    cursor: "pointer",
    backgroundColor: "#ffffff",
    color: props.tabColor,
    borderBottom: `2px solid ${props.tabColor}`,
    width: "100%",
    fontSize: 20,
    textAlign: "left" as "left",
    marginTop: 40,
    padding: "5px 0px",
    marginBottom: 20,
    textTransform: "uppercase" as "uppercase",
  },
  uploadInput: {
    display: "none",
  },
  uploadIcon: {
    position: "absolute" as "absolute",
    right: 0,
    bottom: 5,
    margin: "auto",
  },
  downloadIcon: {
    position: "absolute" as "absolute",
    right: 0,
    bottom: 5,
    margin: "auto",
  },
});

const UploadInput: React.FC<UploadInputProps> = ({
  label,
  onClick,
  fileType,
  fileName,
  onDelete,
  handleChange,
  name,
  id,
}) => {
  const { tabColor } = useUIStore();
  const styles = useCSSRulesWithTheme(getStyles, {
    tabColor: getThemeColorFromAlias(tabColor, theme.colors)!,
  });
  let accept = "";
  switch (fileType) {
    case "pdf":
      accept = "application/pdf";
      break;
    case "kml":
      accept = ".kml";
      break;
    default:
      accept = "application/pdf";
  }

  let inputId = React.useMemo(() => id || `upload-input-${name}`, [id, name]);

  return fileName ? (
    <label htmlFor={inputId} css={styles.inputLabel} onClick={onDelete}>
      {fileName}
      <span css={styles.downloadIcon}>
        <CloseIcon onClick={onDelete} />
      </span>
    </label>
  ) : (
    <label htmlFor={inputId} css={styles.inputLabel}>
      {label}
      <input
        id={inputId}
        type="file"
        css={styles.uploadInput}
        onChange={onClick || handleChange}
        accept={accept}
        name={name}
      />
      <div css={styles.uploadIcon}>
        <UploadIcon />
      </div>
    </label>
  );
};

export default UploadInput;
